import { defineMessages } from 'react-intl';

export const membershipUsersMessages = defineMessages({
    membershipUsers: {
        id: 'membership-users',
        defaultMessage: 'Membership users',
    },
    membershipUsersTableBadge: {
        id: 'membership-users-table-badge',
        defaultMessage: 'Membership users',
    },
    membershipUser: {
        id: 'membership-user',
        defaultMessage: 'Membership user',
    },
    user: {
        id: 'user',
        defaultMessage: 'User',
    },
    users: {
        id: 'users',
        defaultMessage: 'Users',
    },
    admin: {
        id: 'admin',
        defaultMessage: 'Admin',
    },
    member: {
        id: 'member',
        defaultMessage: 'Member',
    },
    guest: {
        id: 'guest',
        defaultMessage: 'Guest',
    },
    accessLevel: {
        id: 'access-level',
        defaultMessage: 'Access level',
    },
    deleteCloudUserSuccess: {
        id: 'delete-cloud-user-success',
        defaultMessage: 'User deleted',
    },
    deleteCloudUserSuccessDescription: {
        id: 'delete-cloud-user-success-description',
        defaultMessage: 'User {name} has been successfully deleted.',
    },
    deleteCloudUserSubtitle: {
        id: 'delete-cloud-user-subtitle',
        defaultMessage: 'Permanently delete user {name}',
    },
    confirmDeleteCloudUser: {
        id: 'confirm-delete-cloud-user',
        defaultMessage: 'Are you sure you want to delete user {name}? This action cannot be undone.',
    },
    updateMembershipCloudUserSuccess: {
        id: 'update-membership-cloud-user-success',
        defaultMessage: 'Membership user updated',
    },
    updateMembershipCloudUserSuccessDescription: {
        id: 'update-membership-cloud-user-success-description',
        defaultMessage: 'Membership user {entry} has been successfully updated.',
    },
    editMembershipCloudUserSubtitle: {
        id: 'edit-membership-cloud-user-subtitle',
        defaultMessage: 'Edit membership user {entry}',
    },
    membershipUserInvitationCreateSuccessDetails: {
        id: 'membership-user-invitation-create-success-details',
        defaultMessage: 'The invitation was successfully sent.',
    },
});
